export const CURRENCY_CREATE_RESET = 'CURRENCY_CREATE_RESET'
export const CURRENCY_CREATE_SET_CREATED = 'CURRENCY_CREATE_SET_CREATED'
export const CURRENCY_CREATE_SET_ERROR = 'CURRENCY_CREATE_SET_ERROR'
export const CURRENCY_CREATE_SET_VIOLATIONS = 'CURRENCY_CREATE_SET_VIOLATIONS'
export const CURRENCY_CREATE_TOGGLE_LOADING = 'CURRENCY_CREATE_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/currency/create/mutation_types.js